import React, { Component } from 'react';
import { GlobalContext } from '../contexts/GlobalContext';
import { withStyles, makeStyles } from '@material-ui/core/styles';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import './RefSetBody.css';
import Backdrop from '@material-ui/core/Backdrop';
import CircularProgress from '@material-ui/core/CircularProgress';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';

import DialogActions from '@material-ui/core/DialogActions';
// import DialogContent from '@material-ui/core/DialogContent';
// import DialogContentText from '@material-ui/core/DialogContentText';
// import DialogTitle from '@material-ui/core/DialogTitle';
// import CodeSystemDialog from './CodeSystemDialog';


class RefSetBody extends Component {
	state = {
		open: false,
		refsetName: "",
		csResource: {},
		// refsetMembers: [{ code: '', display: '' },],
		working: false
	};

	static contextType = GlobalContext;

	static useStyles = makeStyles((theme) => ({
		backdrop: {
			zIndex: theme.zIndex.drawer + 1,
			color: '#fff',
		},
	}));

	// constructor(props) {
	// 	super(props);
	// }

	handleClickOpen = async (e, f) => {
		this.setState({ working: true });
		const { getRefSet } = this.context;
		await getRefSet(e);

		this.setState({ refsetName: f });
		this.setState(
			{
				working: false,
				open: true
			}
		);
	};

	handleClose = () => {
		this.setState({ open: false });
	};

	render() {
		const { refsetsFiltered, refsetMembers } = this.context;
		const columns = [
			{ id: 'code', label: 'Code', width: '10%' },
			{ id: 'display', label: 'Display', width: '90%' },
		];
		const StyledTableCell = withStyles((theme) => ({
			head: {
				backgroundColor: '#383838',
				color: theme.palette.common.white,
			},
			body: {
				fontSize: 14,
			},
		}))(TableCell);

		const dataRows = refsetsFiltered;

		return (
			<React.Fragment>
				<TableContainer className="refSetBody__container">
					<Table stickyHeader className="refSetBody__tableHeader" size="small" aria-label="sticky table">
						<TableHead className="refSetBody__tableHeader">
							<TableRow>
								{columns.map((column) => (
									<StyledTableCell
										key={column.id}
										align={column.align}
										style={{ width: column.width }}
									>
										{column.label}
									</StyledTableCell>
								))}
							</TableRow>
						</TableHead>
						<TableBody>
							{dataRows.map((row) => {
								return (
									<TableRow hover key={row.code}
										onClick={() => {
											this.handleClickOpen(row.code, row[columns[1].id]);
										}}>
										<TableCell key={columns[0].id} align={columns[0].align} >
											{row[columns[0].id]}
										</TableCell>

										<TableCell key={columns[1].id} align={columns[1].align}>
											{row[columns[1].id]}
										</TableCell>

									</TableRow>
								);
							})}
						</TableBody>
					</Table>
					<Backdrop className="codeSystemBody__backdrop" open={this.state.working} >
						<CircularProgress color="inherit" />
					</Backdrop>
				</TableContainer>

				<Dialog fullWidth={true} maxWidth="lg" open={this.state.open}>
					<div className="refSetBody__dialogTitleContainer">
						<div className="refSetBody__dialogTitleParts">
							RefSet : {this.state.refsetName}
						</div>
					</div>
					<TableContainer>
						<Table stickyHeader className="refSetBody__innerContainer" size="small" aria-label="sticky table">
							<TableHead className="refSetBody___tableHeader">
								<TableRow>
									{columns.map((column) => (
										<StyledTableCell
											key={column.id}
											align={column.align}
											style={{ width: column.width }}
										>
											{column.label}
										</StyledTableCell>
									))}
								</TableRow>
							</TableHead>
							<TableBody>
								{refsetMembers.map((row) => {
									return (
										<TableRow hover key={row.code}>
											<TableCell key={columns[0].id} align={columns[0].align} >
												{row[columns[0].id]}
											</TableCell>

											<TableCell key={columns[1].id} align={columns[1].align}>
												{row[columns[1].id]}
											</TableCell>

										</TableRow>
									);
								})}
							</TableBody>
						</Table>
					</TableContainer>
					<DialogActions>
						<Button
							onClick={this.handleClose}
							variant="contained"
							color="primary"
						>
							Close
						</Button>
					</DialogActions>
				</Dialog>
			</React.Fragment>
		);
	}

	emptyList() {
		return (
			<div className="codeSystemBody__codeSystemEmpty">
				<div className="codeSystemBody__codeSystemEmptyText">
					No Code Systems match the filter criteria
				</div>
			</div>
		);
	}

	// createDataList(list, query) {

	// 	const empty = [
	// 		{ code: '', display: '' },
	// 	];

	// 	var newList;

	// 	if (list.resourceType) {
	// 		newList = list.expansion.contains.map((x) => this.createData(x));
	// 		var sorted = newList.sort((a, b) => a.display.localeCompare(b.display));

	// 		var tot = ((query !== "") ? sorted.filter((x) => x.display.toLowerCase().includes(query.toLowerCase())) : sorted);
	// 		this.props.updateCounter(tot.length);
	// 		return ((query !== "") ? sorted.filter((x) => x.display.toLowerCase().includes(query.toLowerCase())) : sorted);
	// 	}
	// 	return empty;
	// }

	// createData(item) {
	// 	const code = item.code;
	// 	const display = item.display;

	// 	return {
	// 		code,
	// 		display
	// 	};
	// }
}

export default RefSetBody;
